import { Link, useLocation, Outlet } from "react-router-dom";
import { Home, Search, MapPin, Mail, LayoutDashboard } from "lucide-react";

const NAV = [
  { to: "/", label: "Inicio", icon: Home, exact: true },
  { to: "/explorar", label: "Explorar", icon: Search },
  { to: "/lugares", label: "Lugares", icon: MapPin },
  { to: "/newsletter", label: "Newsletter", icon: Mail },
  { to: "/admin", label: "Panel", icon: LayoutDashboard },
];

export const Logo = ({ className = "" }) => (
  <Link to="/" className={`font-display text-xl font-extrabold tracking-tight ${className}`} data-testid="logo-link">
    <span className="text-brand">Mirada</span>
    <span className="text-brand-gold">Latina</span>
  </Link>
);

export const Layout = () => {
  const { pathname } = useLocation();
  const isActive = (n) => (n.exact ? pathname === n.to : pathname.startsWith(n.to));
  return (
    <div className="flex min-h-screen flex-col">
      <header className="sticky top-0 z-50 border-b border-brand/10 bg-white/90 backdrop-blur-md">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
          <Logo />
          <nav className="hidden items-center gap-1 md:flex">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.label.toLowerCase()}`}
                className={`rounded-full px-4 py-2 text-sm font-semibold transition-colors ${
                  isActive(n) ? "bg-brand text-white" : "text-brand-ink hover:bg-secondary"
                }`}
              >
                {n.label}
              </Link>
            ))}
          </nav>
        </div>
      </header>

      <main className="flex-1 pb-20 md:pb-0">
        <Outlet />
      </main>

      {/* Mobile bottom nav */}
      <nav className="fixed bottom-0 left-0 right-0 z-50 border-t border-brand/10 bg-white/95 backdrop-blur-md md:hidden">
        <div className="mx-auto flex max-w-lg items-stretch justify-around">
          {NAV.map((n) => {
            const Icon = n.icon;
            const active = isActive(n);
            return (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`bottomnav-${n.label.toLowerCase()}`}
                className={`flex flex-1 flex-col items-center gap-0.5 py-2.5 text-[11px] font-medium no-tap-highlight transition-colors ${
                  active ? "text-brand" : "text-muted-foreground"
                }`}
              >
                <Icon className={`h-5 w-5 ${active ? "scale-110" : ""} transition-transform`} />
                {n.label}
              </Link>
            );
          })}
        </div>
      </nav>

      <footer className="hidden border-t border-brand/10 bg-white py-8 md:block">
        <div className="mx-auto max-w-7xl px-8 text-sm text-muted-foreground">
          <Logo className="text-lg" />
          <p className="mt-2 max-w-md">
            El hub en español para la comunidad latina en Estados Unidos. Directorio de negocios,
            lugares para visitar y newsletter con contenido curado.
          </p>
          <p className="mt-4 text-xs">© {new Date().getFullYear()} MiradaLatina · Mercados semilla de alta calidad</p>
        </div>
      </footer>
    </div>
  );
};
